export const PhoneIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <g clipPath="url(#clip0_1237_245)">
                <path d="M6.62 11.7002L8.82 9.50016C9.1 9.22016 9.18 8.83016 9.07 8.48016C8.7 7.36016 8.5 6.16016 8.5 4.91016C8.5 4.36016 8.05 3.91016 7.5 3.91016H4C3.45 3.91016 3 4.36016 3 4.91016C3 14.3002 10.61 21.9102 20 21.9102C20.55 21.9102 21 21.4602 21 20.9102V17.4202C21 16.8702 20.55 16.4202 20 16.4202C18.76 16.4202 17.55 16.2202 16.43 15.8502C16.08 15.7302 15.68 15.8202 15.41 16.0902L13.21 18.2902C10.38 16.8402 8.06 14.5302 6.62 11.7002Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_1237_245">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.910156)" />
                </clipPath>
            </defs>
        </svg>
    )
}